(()=>{
 'use strict';
 const viewKey='arya.catalog.view.v4';
 let view='grid';
 try{view=localStorage.getItem(viewKey)==='list'?'list':'grid';}catch(_){}
 const showView=next=>{
  view=next==='list'?'list':'grid';
  document.body.dataset.avCatalogView=view;
  document.querySelectorAll('button[data-av-catalog-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.avCatalogView===view)));
 };
 showView(view);
 new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('button[data-av-catalog-view]')||n.querySelector?.('button[data-av-catalog-view]')))))showView(view);}).observe(document.body,{childList:true,subtree:true});
 document.addEventListener('click',event=>{
  const button=event.target.closest('button[data-av-catalog-view]');
  if(!button)return;
  showView(button.dataset.avCatalogView);
  try{localStorage.setItem(viewKey,view);}catch(_){}
 });
 document.addEventListener('shopify:section:load',()=>showView(view));
})();
